import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import vtoCatalogServices from '../../services/vtoCatalogServices'
import { BrandItem } from '../../types/brand'

interface Brands {
  items?: BrandItem[]
  loading: boolean
  error: string | null
}

const initialState: Brands = {
  items: [],
  loading: false,
  error: null,
}

export const getBrandList = createAsyncThunk('vm-bo/brands/getBrandList', () =>
  vtoCatalogServices.getBrandList()
)

const listing = createSlice({
  name: 'vm-bo/listing',
  initialState,
  reducers: {},
  extraReducers: {
    [getBrandList.pending.type]: (state) => {
      state.loading = true
    },
    [getBrandList.fulfilled.type]: (
      state,
      action: PayloadAction<BrandItem[]>
    ) => {
      state.items = action.payload
      state.loading = false
    },
    [getBrandList.rejected.type]: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
  },
})

export default listing.reducer
